/** PayTool product + Pryzm Media company brand (synced with Electron / Flutter). */
export const BRAND = {
  name: "PayTool",
  tagline: "Tap. Pay. Done.",
  productNamePos: "PayTool POS",
  productNameAdmin: "PayTool Admin",
  companyName: "Pryzm Media",
  companyLegal: "Pryzm Media",
  poweredBy: "Powered by Pryzm Media",
  copyright: `© ${new Date().getFullYear()} Pryzm Media`,
  website: "https://paytool.in",
  logo: {
    full: "/assets/transparent_logo.png",
    large: "/assets/paytool_large.png",
    sm: "/assets/logo-32.png",
    md: "/assets/logo-48.png",
    lg: "/assets/logo-56.png",
    xl: "/assets/logo-128.png",
    /** Login / landing hero */
    hero: "/assets/paytool_large.png",
  },
  /** Orange gradient aligned with logo “P” (lighter top → deeper bottom) */
  colors: {
    orange50: "#FFF7ED",
    orange100: "#FFEDD5",
    orange400: "#FB923C",
    orange500: "#F97316",
    orange600: "#EA580C",
    orange700: "#C2410C",
    navy: "#092C4C",
  },
  loginPanelGradient:
    "linear-gradient(165deg, #FFB366 0%, #F97316 38%, #EA580C 72%, #C2410C 100%)",
  favicon: "/favicon.ico",
  appleTouchIcon: "/apple-touch-icon.png",
} as const;
